import { useLang } from 'hooks/lang';

import { Alert, Row } from 'components/Blocks';

export function LegacyAdvise() {
  const { t } = useLang();

  return (
    <Row justifyContent="center">
      <Alert level="info" title={t('legacy-project')} className="max-w-4xl">
        {t('legacy-project-explanation')}
      </Alert>
    </Row>
  );
}
